import { AccessToken } from '../../models/index';
import { StorageGet } from '../storage/index';
import { UseCase } from '../UseCase';

export class GetAccessToken implements UseCase<void, AccessToken | undefined> {
    private storageGet = new StorageGet<AccessToken>();

    execute(): AccessToken | undefined {
        return this.storageGet.execute('oauth.accessToken');
    }
}
